module.exports = __webpack_public_path__ + "static/media/view5.27db3fa2.jpg";